require('./blockSuccessStep.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @helpers
const personalDataHelper = require('utilities/personalDataHelper');

// @ constants
const { CARD_ECARD} = require('constants/index');

class BlockSuccessStep extends React.Component {

    buildReplaceMessage() {
        const { cardReplace, cardReplaceSuccessful, immCard } = this.props;
        const isVirtualCard = immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit')
        let replaceMessage;

        if (cardReplace && cardReplaceSuccessful && !isVirtualCard) {
            replaceMessage = (
                <OKMessage type="important">
                    <FormattedText
                        value="blockSuccesful-replaceMessage"
                    />
                </OKMessage>
            );
        }

        return replaceMessage;
    }

    buildReplaceSection() {
        const {
            cardReplace,
            cardReplaceSuccessful,
            immCard,
            immProfile
        } = this.props;
        let replaceSection;
        
        if (cardReplace) {
            if (cardReplaceSuccessful) {
                const registeredAddress = personalDataHelper.getFormattedAddress(immProfile);
                let replaceText = 'blockSuccesful-replaceText';
                const isVirtualCard = immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit')

                if(isVirtualCard){
                    replaceText += 'VirtualCard'
                }

                if (immCard.get('isViaT')) {
                    replaceText += "ViaT";
                }

                replaceSection = (
                    <section className="block-success__text">
                        <FormattedText value={replaceText} />
                        <div className="block-success__text block-success__text--bold">
                            {!isVirtualCard && registeredAddress}
                        </div>
                        <FormattedText
                            className="block-success__text block-success__text--small"
                            value="blockSuccesful-replaceSubText"
                        />
                    </section>
                );
            } else {
                const cardNumber = immCard.get('number').substr(-4);
                const replaceTextCallNumber = 'blockSuccesful-replaceFailedCallNumber';
                let replaceText = 'blockSuccesful-replaceFailedText';
                let replaceTextTitle = 'blockSuccesful-replaceFailedTitle';

                if (immCard.get('isViaT')) {
                    replaceText += "ViaT";
                    replaceTextTitle = 'blockSuccesful-isBlockedAndNotReplacedViaT';
                }

                replaceSection = (
                    <section>
                        <FormattedText
                            className="block-success__text"
                            value={replaceTextTitle}
                            injectedStrings={[cardNumber]}
                        />
                        <FormattedText
                            className="block-success__text"
                            value={replaceText}
                        />
                        <FormattedText
                            className="block-success__text"
                            value={replaceTextCallNumber}
                        />
                    </section>
                );
            }
        } else {
            if (immCard.get('type') !== CARD_ECARD && !immCard.get('isViaT') && !immCard.get('isVirtualDebit')) {
                const noReplaceText = 'blockSuccesful-noReplaceText';
                const newCardText = 'blockSuccesful-newCard';
                const cardId = immCard.get('cardId');
                const newCardLink = `/myprofile/cards/${cardId}/replace`;
                const hideNewCardLink = immCard.get('isVirtualCredit') && __CONTACT_CENTER__

                replaceSection = (
                    <section>
                        <FormattedText
                            className="block-success__text"
                            value={noReplaceText}
                        />
                        {hideNewCardLink || <OKLink modifier="emphasize" to={newCardLink}>
                            <FormattedText value={newCardText} />
                        </OKLink>}
                    </section>
                );
            } else {
                const cardNumber = immCard.get('number').substr(-4);
                let replaceTextTitle = immCard.get('isViaT') ? 'isBlockedAndNotReplacedViaT': 'replaceFailedTitle';

                replaceSection = (
                    <section>
                        <FormattedText
                            className="block-success__text"
                            value={`blockSuccesful-${replaceTextTitle}`}
                            injectedStrings={[cardNumber]}
                        />
                    </section>
                );

            }
        }

        return replaceSection;
    }

    render() {
        const {
            cardReplace,
            cardReplaceSuccessful,
            immCard
        } = this.props;
        const cardNumber = immCard.get('number').substr(-4);
        const replaceSection = this.buildReplaceSection();
        const replaceMessage = this.buildReplaceMessage();
        const goBackButton = {
            label: formatText('blockSuccesful-backToCard').toUpperCase(),
            url: '/myprofile/cards'
        };

        let title = 'blockSuccesful-cardSuccessfullyBlocked';
        let mainButton = goBackButton;
        let secondaryButton;

        if (cardReplace && !cardReplaceSuccessful) {
            title = 'blockSuccesful-blockPartiallyCompleted';
            mainButton = {
                label: formatText('blockSuccesful-requestNewCard').toUpperCase(),
                modifier: 'secondary ',
                url: `/myprofile/cards/${immCard.get('cardId')}/replace`
            };
            secondaryButton = goBackButton;
        }

        if (immCard.get('isViaT')) {
            title += "ViaT";
        }

        const successMessage = (
            <FormattedText
                injectedStrings={[cardNumber]}
                value={title}
            />
        );


        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardSuccess
                    mainButton={mainButton}
                    secondaryButton={secondaryButton}
                    successMessage={successMessage}
                >
                    <section className="row">
                        <div className="col-xs-6 col-md-7">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-6 col-md-5">
                            {replaceSection}
                        </div>
                        <div className="col-xs-12">{replaceMessage}</div>
                    </section>
                </WizardSuccess>
            </div>
        )
    }
}

BlockSuccessStep.propTypes = {
    cardReplace: PropTypes.bool.isRequired,
    cardReplaceSuccessful: PropTypes.bool.isRequired,
    immCard: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired
};

module.exports = BlockSuccessStep;
